module.exports = __webpack_public_path__ + "img/lung_overlay_posterior.859f997e.png";